export default __webpack_public_path__ + "static/media/Greet.e6a381d6.webm";